import { IPackage } from '~/types/package'
import http from '~/utils/http'

/** 获取所有套餐 */
export function getPackage(page: number, size: number) {
  return http.get('/admin/package', {
    params: {
      page,
      size,
    },
  })
}

/** 新增套餐 */
export function postPackage(data: Partial<IPackage>) {
  return http.post('/admin/package', data)
}

/** 删除套餐 */
export function deletePackage(id: number) {
  return http.delete(`/admin/package/${id}`)
}

/** 编辑套餐 */
export function patchPackage(id: number, data: Partial<IPackage>) {
  return http.patch(`/admin/package/${id}`, data)
}
